import { render } from "./outletOrder.vue?vue&type=template&id=55d37b2f&scoped=true"
import script from "./outletOrder.vue?vue&type=script&lang=js"
export * from "./outletOrder.vue?vue&type=script&lang=js"

import "./outletOrder.vue?vue&type=style&index=0&id=55d37b2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d37b2f"]])

export default __exports__